import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'sentenceCase',
  standalone: false,
})
export class SentenceCasePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    // Ensure the value is a string and handle numbers
    const strValue = String(value);

    // Capitalize the first letter and make the rest lowercase
    const transformedVal =
      strValue.charAt(0).toUpperCase() + strValue.slice(1).toLowerCase();
    return this.sanitizer.bypassSecurityTrustHtml(transformedVal);
  }
}
